/**
 * Refer to the backend default page size here:
 * https://github.com/Frameio/massdriver/blob/23bc6c377ab5c7c7141cd5595f0b97fd7925de9b/apps/db/config/config.exs#L7-L10
 */
export const DEFAULT_INITIAL_PAGE_SIZE = 50;
export const SETTINGS_TABLE_DEFAULT_PAGE_SIZE = 100;

export const EMPTY_OBJECT = Object.freeze({}) as object;

export const DEFAULT_MAX_CHARS = 255;

/** Max character length for editable resource name inputs (Shares, upload links). */
export const NAME_INPUT_MAX_LENGTH = 175;

export const EMPTY_ARRAY = Object.freeze([]) as [];

export const FRAMEIO_MARKETING_URL = 'https://frame.io';

export const DEFAULT_ANIMATION_DURATION = 0.25;

export const FRAMEIO_SUPPORT_EMAIL = 'support@frame.io';

export const GLYPHS = {
  bullet: '•', // U+2022
  middot: '·', // U+00B7
  nbsp: '\u00A0',
};

/**
 * Spread onto secret/passcode inputs to opt out of password-manager autofill
 * and browser caching (per ENT-5968). Covers 1Password (`data-1p-ignore`),
 * LastPass (`data-lpignore`), Bitwarden (`data-bwignore`), Proton Pass
 * (`data-protonpass-ignore`), and Dashlane (`data-form-type="other"`).
 */
export const DISABLE_PASSWORD_MANAGERS = Object.freeze({
  autoComplete: 'off',
  'data-1p-ignore': 'true',
  'data-lpignore': 'true',
  'data-bwignore': 'true',
  'data-protonpass-ignore': 'true',
  'data-form-type': 'other',
});

export const SUPPORT_EMAIL = `mailto:${FRAMEIO_SUPPORT_EMAIL}`;

export const SUPPORT_URL = 'https://help.frame.io';

export const TERMS_OF_SERVICE_URL = 'https://frame.io/terms';
export const ADOBE_TERMS_OF_USE_URL = 'http://www.adobe.com/go/terms';

export const PRIVACY_POLICY_URL = 'https://frame.io/privacy';
export const ADOBE_PRIVACY_POLICY_URL = 'http://www.adobe.com/go/privacy';

export const BILLING_URL = '/settings/billing';

export const MEET_WITH_US_URL = 'https://frame.io/meet-with-us';

export const ADOBE_LOGIN_PATH = '/adobe-login';
export const WELCOME_PATH = '/welcome';
